export { default } from './SearchFacets';



// WEBPACK FOOTER //
// ./src/components/search/SearchFacets/index.js